export default "__VITE_ASSET__CwhgQd6y__"